import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/email-marketing-promo.webp';

const thumbHashString = '9feFBIIrn2B5lkh3mBQKl6OAgHV4GGeHAw==';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.326883206634416;
const originalWidth = 1920;

const EmailMarketingPromo = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default EmailMarketingPromo;
